import { render, staticRenderFns } from "./ClientFields.vue?vue&type=template&id=2cb83d04&scoped=true&"
import script from "./ClientFields.vue?vue&type=script&lang=js&"
export * from "./ClientFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb83d04",
  null
  
)

export default component.exports